module.exports = "https://www.gc-qa.gnp.com.mx/2b59b49cbaf81a80a3351aceea63cfa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Banner_App_Soy_Cliente_GNP_Web_01.png
// module id = 8046
// module chunks = 0